/**
 * Stytch SMS OTP Creation Hook
 *
 * This hook provides functionality for creating TOTP (Time-based One-Time Password)
 * authentication using the Stytch B2B headless client.
 */
import { useCallback } from 'react';
import { getStytchClient } from '../../../../adapters/react/client/headless-client';
export function useStytchDeleteMfaPhoneNumber() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.organization.members.deleteMFAPhoneNumber(data.memberId);
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                memberId: result.member_id,
                member: result.member,
                organization: result.organization,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to delete MFA phone number',
                data: error,
            };
        }
    }, []);
}
export function useStytchDeleteMfaTotp() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.organization.members.deleteMFATOTP(data.memberId);
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                memberId: result.member_id,
                member: result.member,
                organization: result.organization,
                data: result,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to delete MFA TOTP',
                data: error,
            };
        }
    }, []);
}
